import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import { AnalyticsService } from '../../shared/utilities/analytics/analytics.service';
var FAWExProcessComponent = /** @class */ (function () {
    function FAWExProcessComponent(route, router, sharedService, analytics) {
        this.route = route;
        this.router = router;
        this.sharedService = sharedService;
        this.analytics = analytics;
        this.loading = false;
    }
    FAWExProcessComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.route.queryParams.subscribe(function (params) {
            if (params['e']) {
                var request = {
                    x: params['e']
                };
                _this.requestMemberLogin(request);
            }
            else {
                _this.router.navigate(['error']);
            }
        });
    };
    FAWExProcessComponent.prototype.requestMemberLogin = function (request) {
        var _this = this;
        this.sharedService.startExProcess(request).then(function (response) {
            _this.loading = false;
            var data = response.body.data;
            if (data.state !== null) {
                if (data.currentProgress === 'INPROGRESS' || data.currentProgress === 'NEW') {
                    if (data.encryptedUrl) {
                        _this.analytics.track('login-exprocess');
                        window.location.href = data.encryptedUrl;
                    }
                    else {
                        _this.router.navigate(['error']);
                    }
                }
                else if (data.currentProgress === 'COMPLETED' || data.currentProgress === 'AWAITING_APPROVAL') {
                    _this.router.navigate(['process_complete']);
                }
                else { //  (data.currentProgress === 'ERROR' || data.currentProgress === 'UNKNOWN') {
                    _this.router.navigate(['error']);
                }
            }
            else {
                _this.router.navigate(['error']);
            }
        }, function (error) {
            _this.loading = false;
            if (error.status === 409) {
                _this.router.navigate(['expired']);
            }
            else {
                _this.router.navigate(['error']);
            }
        });
    };
    FAWExProcessComponent = __decorate([
        Component({
            selector: 'fawExProcess',
            templateUrl: 'app/smart-exits/faw-ex-process/faw-ex-process.html'
        }),
        __param(2, Inject(SharedService)),
        __metadata("design:paramtypes", [ActivatedRoute,
            Router, Object, AnalyticsService])
    ], FAWExProcessComponent);
    return FAWExProcessComponent;
}());
export { FAWExProcessComponent };
//# sourceMappingURL=data:application/json;base64,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